import React from 'react';
import { TextInput } from '@abyss/web/ui/TextInput';
import { usePropsContext } from 'src/hooks/usePropsContext';

export const TaxID = () => {
  const { modelPrefix, onBlur } = usePropsContext();

  return (
    <TextInput
      data-testid="taxid"
      label="Tax ID number"
      model={`${modelPrefix}.taxId`}
      maxLength={9}
      validators={{
        required: 'Please enter a value',
      }}
      formatter={value => {
        return value.replace(/[^0-9]/g, '');
      }}
      width="50%"
      isClearable
      onBlur={() => onBlur(`${modelPrefix}.taxId`)}
    />
  );
};
